import { css } from "lit";

export const scheduleFormStyles = css`
    :host {
        display: block;
        background-color: white;
        padding: 10px;
    }

    .form {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin: 0;
        flex: 1;
    }

    .colorpicker {
        width: 32px;
        height: 32px;
        cursor: pointer;
    }

    .form-row {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 5px;
    }

    .input {
        width: 100%;
    }

    .form-row-button-center {
        align-self: center;
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 10px;
        margin-top: auto;
    }
`;
